export default "__VITE_ASSET__DjdTVl0o__"